export async function resolve(promise) {
    const resolved = {};
    try {
        resolved.data = await promise;
    } catch(e) {
        resolved.error = e;
    }

    return resolved;
}